//Basic app wide actions we want to share
import Cookies from 'js-cookie';
import Config from '../config/AppConfig';
import {Auth} from 'aws-amplify';
import jwtDecode from 'jwt-decode';

export const APP_ERROR = 'APP_ERROR';

//Basic CreateReducer...
export const createReducer = (initialState, handlers) => {
  return (state = initialState, action) => {
    if (handlers.hasOwnProperty(action.type)) {
      return handlers[action.type](state, action)
    } else {
      return state
    }
  }
}

export const requestStatus = {
  pending: 'pending',
  complete: 'complete',
  rejected: 'rejected',
};

// handle redirects from public site
// duplicates logic from src/main/web/typescript/apps/UserSessionApp/actions.ts in logoutUser
export const getUrlForPublicSite = (path) => {
  const cleanedPath = (path[0] === "/") ? path : ("/" + path);
  if (location.host.slice(-12) === '.bevspot.com' || location.host === 'bevspot.com') {
    return 'https://app.bevspot.com' + cleanedPath
  }
  if (location.host.slice(-12) === '.bevspot.net') {
    return 'https://app-staging.bevspot.net' + cleanedPath;
  }
  return cleanedPath;   // stay on current domain
}

// handle redirects between public site
// duplicates logic from src/main/web/typescript/shared/lib/cookie/impl/CookieManagerImpl.ts in documentCookieSetter
const getCookieDomain = () => {
  let domain = location.host;

  if (domain.slice(-12) === '.bevspot.com') {
    domain = '.bevspot.com';
  }
  if (domain.slice(-12) === '.bevspot.net') {
    domain = '.bevspot.net';
  }

  return domain;
}

export const setCookie = (name, value, expiresInHours) => {
  let args = { domain : getCookieDomain() };

  if (!!expiresInHours) {
    args.expires = expiresInHours / 24;
  }

  Cookies.set(name, value, args);
}

export const deleteCookie = (name) => {
  // this cookie library requires passing the domain that the cookie was set with
  Cookies.remove(name, { domain : getCookieDomain() });
}

export const setSession = async () => {
  const session = await Auth.currentSession();
  const jwtToken = session.getIdToken().getJwtToken();
  const refreshToken = session.getRefreshToken().getToken();
  const accessToken = session.getAccessToken().getJwtToken();
  const {email} = jwtDecode(jwtToken);
  setCookie('userSessionIdentifier', jwtToken, 1);
  setCookie('currentUserEmail', email);
  setCookie('refreshToken', refreshToken);
  setCookie('accessToken', accessToken);
};

export const trackGoogleTagManager = (event, location) => {
  window.dataLayer = window.dataLayer || [];
  window.dataLayer.push({
    event,
    location
  });
  return new Promise((resolve) => {
    setTimeout(resolve, 500); // give the trackers the opportunity to complete
  });
};

export const sizeSwitch = (count) => {
  switch (count) {
    case 2:
      return 48;
    case 3:
      return 29;
    case 4:
      return 19;
    default:
      return 100;
  }
};
